import CodeBlock from "./block-prototype";
import BlockScopeView from "./components/scope";
import BlockContentsView from "./components/block-contents";

export default CodeBlock.extend({
  tagName: "cloned-block",
  className:
    CodeBlock.prototype.className +
    " code-block cloned-block object-like-block",
  template: require("templates/block/block-types/cloned.hbs"),
  initialize() {
    CodeBlock.prototype.initialize.call(this);

    this.defineChildView(
      () =>
        new BlockContentsView({
          model: this.model,
        }),
      "args",
      "> block-body",
    );

    this.defineChildView(
      () =>
        new BlockScopeView({
          model: this.model.get("commands"),
          className:
            BlockScopeView.prototype.className + " horizontal commands",
        }),
      "commands",
      "> object-scope",
    );
  },
});
